export default "__VITE_ASSET__b4d7927c__"